// extracted by mini-css-extract-plugin
export default {"uploadButton":"docsUpload_uploadButton__S8pVb","uploadSvg":"docsUpload_uploadSvg__rp8b3","customFileUploader":"docsUpload_customFileUploader__qS3rT"};